<script lang="ts" setup>
import { computed, useRoute } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import HTInputPassword from '@core/components/HTInputPassword.vue';
import HTInputPhone from '@core/components/HTInputPhone.vue';
import { LoginService } from '@core/services/login.service';
import DedicatedPhoneTip from './DedicatedPhoneTip.vue';

const route = useRoute();
const service = useService(LoginService);

// csp模拟考专用链接
const isDedicatedLink = computed(() => {
  return route.name === 'oj_contest_detail' && !!route.query.uid;
});
</script>

<template>
  <a-form
    :ref="(el) => (service.passwordFormRef = el)"
    class="hetao-form"
    layout="vertical"
    :model="service.model"
    :rules="service.rules"
    @finish="service.handleLoginByPassword"
    @validate="service.handleOnValidate"
  >
    <DedicatedPhoneTip v-if="isDedicatedLink" class="-mt-4 mb-2.5" />
    <a-form-item
      name="phoneNumber"
      :validate-status="service.validModelStatus.phoneNumber"
    >
      <HTInputPhone
        v-model:short="service.model.short"
        v-model:code="service.model.countryCode"
        v-model:value="service.model.phoneNumber"
        v-model:pattern="service.phoneNumberPattern"
        :maxlength="11"
        placeholder="请输入手机号"
        autocomplete="tel"
        :allow-clear="true"
        size="large"
      />
      <template #help>
        <div
          v-if="service.validModelHelp.phoneNumber"
          class="flex h-6 justify-start"
        >
          <ExclamationCircleFilled class="mr-1" />
          <span>{{ service.validModelHelp.phoneNumber }}</span>
        </div>
        <div v-else class="h-6"></div>
      </template>
    </a-form-item>

    <a-form-item
      name="password"
      :validate-status="service.validModelStatus.password"
    >
      <HTInputPassword
        v-model:value="service.model.password"
        :maxlength="18"
        placeholder="请输入登录密码"
        autocomplete="current-password"
        size="large"
      />
      <template #help>
        <div
          v-if="service.validModelHelp.password"
          class="flex h-6 justify-start"
        >
          <ExclamationCircleFilled class="mr-1" />
          <span>{{ service.validModelHelp.password }}</span>
        </div>
        <div v-else class="h-6"></div>
      </template>
    </a-form-item>

    <a-form-item>
      <a-button
        type="primary"
        class="disabled-opacity !text-sm !font-bold"
        block
        html-type="submit"
        size="large"
        :loading="service.loading"
        :disabled="service.formDisabled"
      >
        登录/注册
      </a-button>
    </a-form-item>
  </a-form>
</template>
